import styled from "styled-components";
import { FlexMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
export const SkeletonItem = styled.div.withConfig({
    displayName: "styled__SkeletonItem",
    componentId: "sc-52b02379-0"
})`
	${FlexMixin()}
	background-color: ${({ theme  })=>theme.colors.white.base};
	margin-bottom: 8px;
	position: relative;
	width: 100%;
`;
export const SkeletonImages = styled.div.withConfig({
    displayName: "styled__SkeletonImages",
    componentId: "sc-52b02379-1"
})`
	margin-right: 16px;
	min-width: 112px;
`;
export const SkeletonContent = styled.div.withConfig({
    displayName: "styled__SkeletonContent",
    componentId: "sc-52b02379-2"
})`
	min-width: calc(100% - 128px);

	& div:first-child {
		margin-top: 16px;
	}

	& div {
		margin-bottom: 14px;
		min-heigh: 18px;
	}
`;

//# sourceMappingURL=styled.js.map